export default {

    booting(state, payload) {
        state.booting = payload;
        return state;
    },

    currentPaneId(state, payload) {
        state.currentPaneId = payload;
        return state;
    },

    prevPaneId(state, payload) {
        state.prevPaneId = payload;
        return state;
    },

    openedPaneIds(state, payload) {
        state.openedPaneIds = payload;
        return state;
    },

    paneOptionsComponents(state, payload) {
        state.paneOptionsComponents = payload;
        return state;
    },

    currentMapFilterCode(state, payload) {
        state.currentMapFilterCode = payload;
        return state;
    },

    openedMapFilterCodes(state, payload) {
        state.openedMapFilterCodes = payload;
        return state;
    },

    currentPrimaryPaneOptionComponentId(state, payload) {
        state.currentPrimaryPaneOptionComponentId = payload;
        return state;
    },

};